import { isMobileOnly, isTablet } from "../util/deviceDetect";

const getDevice = () => {
    if (!window?.navigator?.userAgent) {
        return false;
    }

    if (isMobileOnly) {
        return "mobile";
    } else if (isTablet) {
        return "tablet";
    } else {
        return "desktop";
    }
};

export { getDevice };
